module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "loi"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pviii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pix"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/haldipur0006#toc"
    }
  }, [_vm._v("List of Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Figure I.1: The 40th, 42nd, and 44th Precincts of the New York Police Department")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Figure I.2: 161st Street near the Bronx Hall of Justice")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Figure I.3: 138th Street in the 40th Precinct")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Figure I.4: New York City murders, 2002–2016")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Figure I.5: NYPD stop and frisks, 2002–2016")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Figure 1.1: Two boys play basketball using a makeshift hoop")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Figure 3.1: A mother and her child attempt to beat the summer heat")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Figure 4.1: A neighborhood corner store")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Figure 4.2: A group of men play dominoes on the sidewalk")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48fefdee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/haldipur-0007.vue
// module id = 72
// module chunks = 0